<template>
    <div class="communityComment">
        <div id="CLUBCMT" class="CLUBCMT" :sid="commontId"></div>
    </div>
</template>
<script>
export default {
    name: "communityComment",
    mounted() {
        this.initCLUBCMT();
    },
    computed: {
        commontId() {
            return this.$store.state.commontId;
        }
    },
    watch: {
        commontId(val) {
            this.initCLUBCMT();
        }
    },
    methods: {
        initCLUBCMT() {
            this.$nextTick(() => {
                if (this.$store.state.commontId != 0) {
                    $.getScript(
                        "//j.gamersky.com/user/emote/emoji.js?v=" + dateFtt({ h: 1 }),
                        function (script, textStatus, jqXHR) {
                            $.getScript(
                                // 正式地址
                                "https://www.gamersky.com/zhuanti/wqj2022/ccmtconfig.js?v=" + dateFtt({ f: 10 }),
                                 
                            //     // 测试地址
                            //    "https://project-test.gamersky.com/wqj2022/wqj2022/ccmtconfig.js?v=" + dateFtt({ f: 10 }),
                                function (script, textStatus, jqXHR) {}
                            );
                        }
                    );
                }
            }
            );
        }
    }
};
</script>
<style lang="scss" scoped>
.communityComment {
    width: 722px;
    background: #ffffff;
    padding: 15px 30px;
    border-radius: 10px;
    overflow: hidden;
    margin-right: 30px;
}
.ccmt_msg .qzcmt-piclist li {
    overflow: hidden !important;
}
</style>
